namespace TabAurous.Inventory {
    export namespace SKUItemsService {
        export const baseUrl = 'Inventory/SKUItems';

        export declare function Create(request: Serenity.SaveRequest<SKUItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SKUItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SKUItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SKUItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetSKUDetails(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SKUItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/SKUItems/Create",
            Update = "Inventory/SKUItems/Update",
            Delete = "Inventory/SKUItems/Delete",
            Retrieve = "Inventory/SKUItems/Retrieve",
            List = "Inventory/SKUItems/List",
            GetSKUDetails = "Inventory/SKUItems/GetSKUDetails"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetSKUDetails'
        ].forEach(x => {
            (<any>SKUItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
